import router from '@/router/index.js';
import config from '@/config/prod.env';
import { authenticationService } from '@/services/authentication/authentication.service.js';
import { menuService } from '@/services/authentication/menu.service.js';

const user = JSON.parse(localStorage.getItem('user'));

const state = (user) ? { status: { loggedIn: true }, user }
	: ((user && Date.parse(user.expiresTime) > Date.now()) ? { status: { loggedIn: true }, user } : { status: { loggedIn: false }, user: null });

const actions = {
	async login({ dispatch, commit }, { userName, password, appId }) {
		await authenticationService.login(userName, password, appId).then(
			(res) => {
				if (res.code) {
					let appInfo = res.data.appInfo.filter(e => e.appId == appId)[0] ? res.data.appInfo.filter(e => e.appId == appId)[0] : null
					if (appInfo) {
						window.location.href = appInfo.appDomain + '/?login=' + res.data.loginInfoId
					}
				}
				else {
					dispatch('alert/error', res.data.message, { root: true });
				}
			},
			(err) => {
				let message = err.message;
				if (message === 'Failed to fetch') message = 'Không thể kết nối tới máy chủ';
				dispatch('alert/error', message, { root: true });
				console.log(err);
			}
		);
	},

	async logout({ commit }) {
		await authenticationService.logout();
		commit('logout');
		router.push({ path: '/login' });
	},

	async register({ dispatch, commit }, user) {
		return await authenticationService.register(user).then(
			(res) => {
				if (res.statusCode == 200) {
					dispatch('alert/success', 'Đăng ký tài khoản thành công', { root: true });
					return true;
				}
				else {
					dispatch('alert/error', res.message, { root: true });
					return false;
				}
			},
			(err) => {
				let message = err.message;
				if (message === 'Failed to fetch') message = 'Không thể kết nối tới máy chủ';
				dispatch('alert/error', message, { root: true });
				console.log(err);
				return false;
			}
		);
	},

	async changePassword({ dispatch, commit }, { password, passwordNew, passwordNewConfirmed }) {
		return await authenticationService.changePassword(password, passwordNew, passwordNewConfirmed).then(
			(res) => {
				if (res.statusCode == 200) {
					dispatch('alert/success', 'Đổi mật khẩu thành công', { root: true });
					return true;
				}
				else {
					dispatch('alert/error', res.message, { root: true });
					return false;
				}
			},
			(err) => {
				let message = err.message;
				if (message === 'Failed to fetch') message = 'Không thể kết nối tới máy chủ';
				dispatch('alert/error', message, { root: true });
				console.log(err);
				return false;
			}
		);
	},

	async resetPassword({ dispatch, commit }, userName) {
		return await authenticationService.resetPassword(userName).then(
			(res) => {
				if (res.statusCode == 200) {
					dispatch('alert/success', 'Reset mật khẩu thành công', { root: true });
					return true;
				}
				else {
					dispatch('alert/error', res.message, { root: true });
					return false;
				}
			},
			(err) => {
				let message = err.message;
				if (message === 'Failed to fetch') message = 'Không thể kết nối tới máy chủ';
				dispatch('alert/error', message, { root: true });
				console.log(err);
				return false;
			}
		);
	},

	async updateAccountInfo({ dispatch, commit }, model) {
		return await authenticationService.updateAccountInfo(model).then(
			(res) => {
				if (res.statusCode == 200) {
					dispatch('alert/success', 'Cập nhật thông tin thành công', { root: true });
					return true;
				}
				else {
					dispatch('alert/error', res.message, { root: true });
					return false;
				}
			},
			(err) => {
				let message = err.message;
				if (message === 'Failed to fetch') message = 'Không thể kết nối tới máy chủ';
				dispatch('alert/error', message, { root: true });
				console.log(err);
				return false;
			}
		);
	},
};

const mutations = {
	loginSuccess(state, user) {
		state.status = { loggedIn: true };
		state.user = user;
	},
	logout(state) {
		state.status = {};
		state.user = null;
	},
};

export const authentication = {
	namespaced: true,
	state,
	actions,
	mutations,
};
